import { gql } from '@apollo/client';

export const QUERY_FIND_MANY_ENTITY_METADATA = gql`
    query FindManyEntityMetadata($data: FindManyEntityMetadataInput!) {
        findManyEntityMetadata(data: $data) {
            id
            enabled
            tenantUniqueId
            arMethod
            businessEntity {
                id
                displayName
            }
            tenant {
                id
                name
            }
            createdAt
            updatedAt
            createdBy {
                id
                name
            }
            updatedBy {
                id
                name
            }
        }
    }
`;
